import React from 'react';
import classNames from "classnames";
import styles from "../styles/betting-zone.drawer-menu.module.scss";
import {observer} from "mobx-react";
import {SettingsModule} from "../../../../../apps/website/modules/drawer-module/components/pages/settings/components/settings-module";
import {BettingZoneDrawerMenuItemArrow} from "./betting-zone.drawer-menu.item-arrow";
import {SettingsIcon} from "../../../../../apps/website/modules/drawer-module/components/sidebar/icons/settings-icon";
import {useThemeColor} from "../../../../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../../../../../core/app/consts/colors";
import {MAIN_HEADER_MODULE} from "../../../../../apps/website/modules/main-header/main-header-module.consts";
import {BETTING_CONTAINER} from "../../../betting-container-consts";

export const BettingZoneDrawerMenuSettings = observer(({controller, expandedItemId, selectedItem, setExpandedItemId, setIsMenuVisible}) => {
  if(selectedItem !== null) {
    return null
  }

  const {terms: {SETTINGS_TITLE}} = controller;
  const isSetting: Boolean = expandedItemId === 'settings';

  const settingProps = {
    className: classNames(styles.settings_container),
    setIsMenuVisible
  }

  const settingsItem = {
    id: 'settings',
    hasItems: true,
    viewType: BETTING_CONTAINER.MENU_VIEW_TYPE.accordion
  };

  const iconProps = {
    color: useThemeColor(COLORS.textPrimary),
    width: MAIN_HEADER_MODULE.ICON_SIZE,
    height: MAIN_HEADER_MODULE.ICON_SIZE
  };

  const arrowProps = {
    controller,
    expandedItemId,
    item: settingsItem
  }

  return <>
    <li className={classNames(styles.item)} key={'settings'}>
      <div className={classNames(styles.item_settings)} onClick={() => setExpandedItemId(!isSetting ? 'settings' : null)}>
        <div className={classNames(styles.item_labels)}>
          <div className={classNames(styles.item_icon_container)}>
            <SettingsIcon {...iconProps}/>
          </div>
          {SETTINGS_TITLE}
        </div>
        <BettingZoneDrawerMenuItemArrow {...arrowProps}/>
      </div>
    </li>
    {
      isSetting ? <SettingsModule {...settingProps}/> : null
    }
  </>
});